import { DashboardCard } from "@dashboard/components/Card";
import { Box, Skeleton, Text } from "@saleor/macaw-ui-next";
import { MessageSquareTextIcon } from "lucide-react";
import { FormattedMessage, useIntl } from "react-intl";

interface OrderCustomerNoteProps {
  note: string;
  // When true and the note is not empty, the note is rendered as a prominent
  // callout so staff immediately notice a request left by the customer.
  highlighted?: boolean;
}

const OrderCustomerNote = ({ note, highlighted = false }: OrderCustomerNoteProps) => {
  const intl = useIntl();
  const hasNote = !!note;

  const title = intl.formatMessage({
    id: "puALFo",
    defaultMessage: "Notes",
    description: "notes about customer, header",
  });

  if (highlighted && hasNote) {
    return (
      <Box
        data-test-id="order-customer-note"
        display="flex"
        gap={3}
        alignItems="flex-start"
        backgroundColor="warning1"
        color="warning1"
        borderColor="warning1"
        borderWidth={1}
        borderStyle="solid"
        borderRadius={3}
        paddingX={5}
        paddingY={4}
        marginY={2}
      >
        <Box marginTop={1} display="flex" color="warning1">
          <MessageSquareTextIcon size={16} />
        </Box>
        <Box display="flex" flexDirection="column" gap={1}>
          <Text size={1} color="warning1" fontWeight="medium" textTransform="uppercase">
            {title}
          </Text>
          <Text
            color="warning1"
            fontWeight="bold"
            style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
          >
            {note}
          </Text>
        </Box>
      </Box>
    );
  }

  return (
    <DashboardCard data-test-id="order-customer-note">
      <DashboardCard.Header>
        <DashboardCard.Title>{title}</DashboardCard.Title>
      </DashboardCard.Header>
      <DashboardCard.Content>
        {note === undefined ? (
          <Skeleton />
        ) : note === "" ? (
          <Text color="default2">
            <FormattedMessage id="VrFy8e" defaultMessage="No notes from customer" />
          </Text>
        ) : (
          <Text>{note}</Text>
        )}
      </DashboardCard.Content>
    </DashboardCard>
  );
};

export default OrderCustomerNote;
